<ul class="eshava-navigation"
  role="navigation">
  @for (scrollSpyItem of scrollSpyItems; track scrollSpyItem) {
    @if (!scrollSpyItem.isHidden) {
      <li>
        <a [scrollSpyListItem]="scrollSpyItem"
          activeClass="eshava-active"
          href="{{ '#' + scrollSpyItem.anchor }}"
          [intersectionName]="scrollSpyItem.intersectionName ?? intersectionName"
          [attr.href]="url + '#' + scrollSpyItem.anchor"
        (click)="onClick($event, scrollSpyItem.anchor)"> {{ scrollSpyItem.text }} </a>
      </li>
    }
  }
</ul>
